import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './PostFormDrawers.module.css';
import ContentCategorySelector from 'components/Posts/PostForm/ContentCategorySelector/ContentCategorySelector';
import ModalDrawer from 'components/UI/Modal/ModalDrawer/ModalDrawer';
import LocationSelector from 'containers/Maps/LocationSelector/LocationSelector';
import About from 'containers/Posts/PostForm/About/About';
import GiftPost from 'containers/Posts/PostForm/GiftPost/GiftPost';
import ImagesManager from 'containers/Posts/PostForm/ImagesManager/ImagesManager';
import LogSelector from 'containers/Posts/PostForm/LogSelector/LogSelector';
import Title from 'containers/Posts/PostForm/Title/Title';
import DateTimePicker from 'containers/UI/DateSelection/DateTimePicker/DateTimePicker';
import TagSelector from 'containers/UI/Tags/TagSelector/TagSelector';
import PostFormUppy from 'containers/Uppy/Dashboard/PostFormUppy/PostFormUppy';
import { getRgbFromColorName } from 'shared/utility';

class PostFormDrawers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // uppyTitle: 'Images',
      showReorderOption: false,
      // uppyState: null,
    };
  }

  closeDrawer = () => {
    const { openedDrawer, toggleRenderStatus } = this.props;
    if (openedDrawer === 'Ideas') {
      toggleRenderStatus('Add Title');
    } else if (openedDrawer === 'Times') {
      toggleRenderStatus('Dates');
    } else if (openedDrawer === 'Reorder') {
      toggleRenderStatus('Reorder');
    } else {
      toggleRenderStatus(null);
    }
  };

  toggleReorderer = () => {
    if (this.state.showReorderOption === true) {
      this.setState({ showReorderOption: false });
    } else {
      this.setState({ showReorderOption: true });
    }
  };

  relaunchFileUploader = () => {
    const { toggleRenderStatus } = this.props;
    toggleRenderStatus('FilePicker');
    this.setState({ showReorderOption: false });
  };

  render = () => {
    const { controls, shortWindow, openedDrawer } = this.props;
    const drawerWithoutHeaders = ['Location', 'Reorder'];
    const uppyDrawers = ['FilePicker', 'Upload', 'Uploaded', 'Select Files'];
    let closeText = openedDrawer === 'Times' ? 'Dates' : '';
    if (openedDrawer === 'Ideas') closeText = 'Add Title';
    const hideCaret = openedDrawer === 'Reorder';
    const hideHeader = drawerWithoutHeaders.includes(this.props.openedDrawer);
    let logSelector = null;
    let gifteeSelector = null;
    let contentCategorySelector = null;
    let title = null;
    let about = null;
    let dateTimePicker = null;
    let tags = null;
    let imagesManager = null;
    let locationSelector = null;
    if (this.props.openedDrawer === 'Logs') {
      logSelector = (
        <LogSelector
          shortWindow={shortWindow}
          handleUpdateLogControls={this.props.handleUpdateLogControls}
          selectedLogs={controls.logs.value}
          logs={this.props.postingAs.Logs ? this.props.postingAs.Logs : []}
        />
      );
    }

    if (this.props.openedDrawer === 'Gift To') {
      gifteeSelector = (
        <GiftPost
          shortWindow={shortWindow}
          loading={this.props.loadingLogs}
          postingAsUserId={this.props.postingAs.UserId}
          gifteeMemberIds={controls.gifteeMembers.ids}
          gifteeLogIds={controls.gifteeLogs.ids}
          members={this.props.postingAs.KnownUsers !== null ? this.props.postingAs.KnownUsers : []}
          logs={this.props.logs !== null ? this.props.logs.filter((log) => log.Users !== undefined && log.Users.length > 1) : []}
          handleGifteesUpdate={this.props.handleGifteesUpdate}
          handleGifteeLogsUpdate={this.props.handleGifteeLogsUpdate}
          handleGifteesClear={this.props.handleGifteesClear}
        />
      );
    }

    if (this.props.openedDrawer === 'Choose Content Type') {
      contentCategorySelector = (
        <ContentCategorySelector selectedCategory={this.props.selectedCategory} shortWindow={shortWindow} clicked={this.props.setContentCategory} />
      );
    }

    if (this.props.openedDrawer === 'Add Title' || this.props.openedDrawer === 'Ideas') {
      title = (
        <Title
          shortWindow={shortWindow}
          toggleRenderStatus={this.props.toggleRenderStatus}
          openedDrawer={this.props.openedDrawer}
          value={controls.title.value}
          placeholder={controls.title.elementConfig.placeholder}
          contentCategory={controls.contentCategory.value}
          setContentCategory={this.props.setContentCategory}
          handleCategoryPromptSelection={this.props.handleCategoryPromptSelection}
          updateTags={this.props.updateTags}
          changed={(event) => this.props.inputChangedHandler(event, 'title')}
          invalid={!controls.title.valid}
          shouldValidate={controls.title.validation}
          validationError={controls.title.validation.required === true ? controls.title.validation.validationError : null}
          touched={controls.title.touched}
        />
      );
    }

    if (this.props.openedDrawer === 'About') {
      about = (
        <About
          shortWindow={shortWindow}
          value={controls.desc.value}
          placeholder={controls.desc.elementConfig.placeholder}
          changed={(event) => this.props.inputChangedHandler(event, 'desc')}
          invalid={!controls.desc.valid}
          shouldValidate={controls.desc.validation}
          validationError={controls.desc.validation.required === true ? this.state.controls.desc.validation.validationError : null}
          touched={controls.desc.touched}
        />
      );
    }
    if (this.props.openedDrawer === 'Dates' || this.props.openedDrawer === 'Times') {
      dateTimePicker = (
        <DateTimePicker
          openedDrawer={this.props.openedDrawer}
          visible
          dateStart={controls.dateStart.value}
          timeStart={controls.timeStart.value}
          dateEnd={controls.dateEnd.value}
          ongoing={controls.dateEnd.ongoing}
          timeEnd={controls.timeEnd.value}
          toggleRenderStatus={this.props.toggleRenderStatus}
          handleTimeSelect={this.props.handleTimeSelect}
          handleTimeClear={this.props.handleTimeClear}
          handleDateSelect={this.props.handleDateSelect}
          handleDateClear={this.props.handleDateClear}
          handleOngoingSelection={this.props.handleOngoingSelection}
        />
      );
    }
    if (this.props.openedDrawer === 'Tags') {
      tags = (
        <TagSelector
          type="PostForm"
          shortWindow={shortWindow}
          tagsLoaded={this.props.tags.loaded}
          whatTagsList={[...this.props.tags.WhatTags].filter((tag) => !controls.whatTags.value.includes(tag))}
          whoTagsList={[...this.props.tags.WhoTags].filter((tag) => !controls.whoTags.value.includes(tag))}
          locationTagsList={[...this.props.tags.LocationTags].filter((tag) => !controls.locationTags.value.includes(tag))}
          selectedWhatTags={controls.whatTags.value}
          selectedWhoTags={controls.whoTags.value}
          selectedLocationTags={controls.locationTags.value}
          tagCategory="whatTags"
          updateTags={this.props.updateTags}
        />
      );
    }

    if (this.props.openedDrawer === 'Location') {
      const useDefaultSettings = !(controls.location.location.length > 0 || controls.location.location2.length > 0);
      const location =
        controls.location.location.length > 0 ? `${controls.location.location}, ${controls.location.location2}` : controls.location.location2;
      locationSelector = (
        <LocationSelector
          shortWindow={shortWindow}
          address={location}
          location={controls.location}
          locationSelected={!useDefaultSettings}
          geoLocation={useDefaultSettings ? this.props.defaultMapSettings.geoLocation : controls.location.geoLocation}
          center={useDefaultSettings && controls.location.center.lat === null ? this.props.defaultMapSettings.center : controls.location.center}
          includeMarker={!useDefaultSettings}
          markerColor={this.props.postingAs.Color ? getRgbFromColorName(this.props.postingAs.Color) : null}
          zoom={useDefaultSettings && controls.location.zoom === null ? this.props.defaultMapSettings.zoom : controls.location.zoom}
          mapTypeId={useDefaultSettings ? this.props.defaultMapSettings.mapTypeId : controls.location.mapTypeId}
          pitch={controls.location.pitch}
          heading={controls.location.heading}
          handleLocationUpdate={this.props.handleLocationUpdate}
          handleLocationDeletion={this.props.handleLocationDeletion}
        />
      );
    }

    if (this.props.openedDrawer === 'Reorder') {
      imagesManager = (
        <div>
          <ImagesManager
            done={this.closeDrawer}
            plus={this.relaunchFileUploader}
            shortWindow={shortWindow}
            images={this.props.images}
            handlePostImageReorder={this.props.handlePostImageReorder}
            handleImageDeletion={this.props.handleImageDeletion}
          />
        </div>
      );
    }

    const filePicker = (
      <div className={this.props.openedDrawer === 'FilePicker' ? [classes.FilePickerContainer, classes.Show].join(' ') : classes.FilePickerContainer}>
        <PostFormUppy
          shortWindow={shortWindow}
          updateUppyState={this.updateUppyState}
          title={this.props.openedDrawer}
          updateTitle={this.props.toggleRenderStatus}
          showReorderOption={this.state.showReorderOption}
          toggleReorderer={() => this.props.toggleRenderStatus('Reorder')}
          handleUppyUploadStart={this.props.handleUppyUploadStart}
          handleUppyUploadCompletion={this.props.handleUppyUploadCompletion}
        />
        {this.state.showReorderOption === true && this.props.images.length > 0 ? (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
          <span className={classes.ReorderButton} onClick={() => this.props.toggleRenderStatus('Reorder')}>
            Reorder
          </span>
        ) : null}
      </div>
    );

    return (
      <ModalDrawer
        show={this.props.show}
        shortWindow={shortWindow}
        title={uppyDrawers.includes(this.props.openedDrawer) ? 'Images' : this.props.openedDrawer}
        close={this.closeDrawer}
        closeText={closeText}
        hideCaret={hideCaret}
        hideHeader={hideHeader}
      >
        {logSelector}
        {gifteeSelector}
        {contentCategorySelector}
        {title}
        {about}
        {dateTimePicker}
        {tags}
        {filePicker}
        {imagesManager}
        {locationSelector}
      </ModalDrawer>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    postingAs: state.user.postingAs,
    tags: state.logs.Tags,
    loadingImages: state.post.loading,
    loadingLogs: state.logs.loading,
  };
};

export default connect(mapStateToProps)(PostFormDrawers);
